import type { PolymarketMarket } from './types';

function normalizeKeyPart(value?: string | number | null) {
  const normalized = String(value ?? '').trim();
  return normalized || null;
}

export function getMarketKey(market: PolymarketMarket) {
  const marketId = normalizeKeyPart(market.market_id);
  if (marketId) return `id:${marketId}`;

  const fallbackParts = [
    market.condition_id,
    market.clob_tokens_id_yes,
    market.market_slug,
    market.group_item_title,
    market.outcome_yes,
    market.market_question,
  ]
    .map(normalizeKeyPart)
    .filter((part): part is string => Boolean(part));

  return fallbackParts.length ? `fallback:${fallbackParts.join('|')}` : '';
}
